import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import Typography from '../Typography';
import styles from './Breadcrumb-tw-styles';
import i18nMessages from '../../../constants/messages/pt-BR';

class BreadcrumbItem extends PureComponent {
  state = {
    isMobile: false,
  };
  componentDidMount() {
    window.addEventListener(i18nMessages.resize, this.handleWindowChange);
    this.handleWindowChange();
  }
  componentWillUnmount() {
    window.removeEventListener(i18nMessages.resize, this.handleWindowChange);
  }
  handleWindowChange = () => {
    const isMobile = window.innerWidth < 768;
    this.setState({
      isMobile: isMobile,
    });
  };
  render() {
    let {
      className,
      linkClassName,
      component: Component,
      keyIndex,
      active,
      labelText,
      separator,
      to,
      ...other
    } = this.props;
    const { isMobile } = this.state;
    let truncate = labelText;
    if (isMobile && active && labelText.length > 26) {
      truncate = labelText.substring(0, 27) + '...';
    }
    const element = active ? (
      <Typography
        className={classNames(styles.breadcrumb.item, linkClassName)}
        itemProp="name"
        component="span"
        tabIndex={0}
      >
        {truncate}
      </Typography>
    ) : (
      <Button
        data-pgaction-redirection="0"
        className={classNames(linkClassName)}
        itemProp="item"
        to={to}
        title={labelText}
      >
        <Typography itemProp="name" component="span">
          {labelText}
        </Typography>
      </Button>
    );

    return (
      <Component className={className} key={`${keyIndex}`} {...other}>
        {element}
        {!active ? (
          <span
            className={classNames(styles.breadcrumb.separator, 'separator')}
          >
            {separator}
          </span>
        ) : null}
        <meta itemProp="position" content={`${keyIndex + 1}`} />
      </Component>
    );
  }
}

BreadcrumbItem.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  linkClassName: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  separator: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Explaining about active or current page
   */
  active: PropTypes.bool,
  /**
   * The label of the element.
   */
  labelText: PropTypes.string.isRequired,
  /**
   * The URL for redirection.
   */
  to: PropTypes.string,
  /**
   * Unique key identifier.
   */
  keyIndex: PropTypes.number.isRequired,
};

BreadcrumbItem.defaultProps = {
  component: 'li',
  active: false,
  separator: null,
  to: '',
  className: '',
  linkClassName: '',
};

export default BreadcrumbItem;
